/**
 * A Util support for handling some function about Object
 * Allowed using javascript methods
 */
export class ObjectUtil {
  /**
   * an function return value from an object
   * @param object an Objection of data need to get value
   * @param props properties to get value Ex: 'a' | 'a.b.c' || ['a', 'b', 'c']
   * @returns any
   */
  public static queryValue(
    object: { [key: string]: any },
    props: string | string[]
  ): any {
    const properties = props instanceof Array ? props : props.split('.');

    let _value = object;

    while (properties.length) {
      const _prop = properties.shift();
      if (!_prop) {
        break;
      }

      _value = _value[_prop];
      if (!_value) {
        break;
      }
    }

    return _value;
  }

  /**
   * Will check json object empty or not
   *
   * @param {object | null | undefined} value
   * @returns boolean
   */
  public static isObjectEmpty(value: object | null | undefined): boolean {
    return value === undefined || value === null || Object.keys(value).length === 0;
  }

  /**
   * sort array object by key
   * @param {{ [key: string]: any }[]} data
   * @param { string } key
   */
  public static sortByKey(data: { [key: string]: any }[], key: string): any {
    data.sort(function (a, b) {
      const firstItem = a[key].toUpperCase();
      const secondItem = b[key].toUpperCase();
      return firstItem < secondItem ? -1 : firstItem > secondItem ? 1 : 0;
    });

    return data;
  }
}
